import { ShiftDetails } from "@lemmonhq/types";
import { getAPIClient } from "../helpers";
import { DateRange } from "@app/vue/components/UIComponents";

export const shiftsAPI = {
  getShifts: async (attrs: {
    page: number;
    limit: number;
    dateRange: DateRange;
    userId?: number;
  }): Promise<{
    pagination: {
      total: number;
      page: number;
      limit: number;
      total_pages: number;
    };
    data: ShiftDetails[];
  }> => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.shifts.$get({
      query: {
        page: attrs.page + "",
        limit: attrs.limit + "",
        ...(attrs.userId && { userId: attrs.userId + "" }),
        ...(attrs.dateRange.startDate && {
          start_date: attrs.dateRange.startDate,
        }),
        ...(attrs.dateRange.endDate && { end_date: attrs.dateRange.endDate }),
      },
    });
    if (resp.ok) {
      const json = await resp.json();
      return json as any;
    } else {
      const json = await resp.json();
      throw new Error("unable to  find");
    }
  },
  getActiveShift: async () => {
    // api/v2/shifts/active
    const hc = getAPIClient();
    const resp = await hc.api.v2.shifts.active.$get();
    if (resp.ok) {
      const r = await resp.json();
      return r;
    } else {
      const err: any = await resp.json();
      throw new Error(err.message || "failed getting active shift");
    }
  },
};
